import React, { useEffect, useState } from "react";
import "./Carousel.css"; // Add this CSS file for styles
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { SubscriptionModal } from "../../subscriptionModal/subscriptionModal";

const EpisodeCarousel = ({ slides, isSubscribed, loading }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(4);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const getUnlocked = (slide) => {
    if (isSubscribed) {
      return slide?.is_unlock ?? false; // fallback only if undefined
    }
    return slide?.can_access;
  };
  useEffect(() => {
    const updateSlidesPerView = () => {
      if (window.innerWidth <= 575) {
        setSlidesPerView(1);
      } else if (window.innerWidth <= 767) {
        setSlidesPerView(2);
      } else if (window.innerWidth <= 991) {
        setSlidesPerView(3);
      } else {
        setSlidesPerView(4);
      }
    };

    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);

    return () => {
      window.removeEventListener("resize", updateSlidesPerView);
    };
  }, []);

  const goToNext = () => {
    setActiveIndex((prevIndex) =>
      Math.min(prevIndex + 1, (slides?.length || 0) - slidesPerView),
    );
  };

  const goToPrev = () => {
    setActiveIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };
  const navigate = useNavigate();
  // const handleClick = (e) => {
  // console.log(accessType);
  // if (accessType === "subscription" && status === "2") {
  //   e.preventDefault(); // Prevent default link behavior
  //   setShowSubscriptionModal(true); // Show modal
  // } else {
  // navigate(`/student/admin/episodes/detail/${questId}/${chapterId}`);
  // window.location.reload();
  // }
  // };

  if (loading) {
    return (
      <div
        id="carouselExample"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="carousel-items-container">
              {Array.from({ length: 4 }).map((_, index) => (
                <div
                  key={index}
                  className="carousel-item-slide-new text-center"
                >
                  <div className="card-body">
                    <div className="QuestEpisodeCard position-relative">
                      <Skeleton
                        width="100%"
                        borderRadius={16}
                        style={{
                          aspectRatio: "1 / 1.1",
                          borderRadius: "16px",
                          display: "block",
                        }}
                      />
                    </div>
                    <p className="EpisodeTitle mb-0">
                      <Skeleton width={80} />
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      id="carouselExample"
      className="carousel slide"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div
            className="carousel-items-container"
            style={{
              transform: `translateX(-${(activeIndex * 100) / slidesPerView}%)`,
              transition: "transform 0.5s ease",
            }}
          >
            {showSubscriptionModal && (
              <SubscriptionModal
                handleClose={() => setShowSubscriptionModal(false)}
                showSubscriptionModal={showSubscriptionModal}
                navigateUrl={`/student/admin/quests`}
              />
            )}
            {slides
              ?.filter((slide) => slide.status === "1")
              ?.map((slide) => {
                const content = (
                  <div className="QuestEpisodeCard position-relative">
                    {slide.loading ? (
                      <Skeleton
                        width="100%"
                        borderRadius={16}
                        style={{
                          aspectRatio: "1 / 1.1",
                          borderRadius: "16px",
                          display: "block",
                        }}
                      />
                    ) : (
                      <>
                        <img
                          src={slide.thumbnail_url}
                          alt={slide.title}
                          className="w-100"
                          style={{
                            width: "100%",
                            height: "auto",
                            filter: getUnlocked(slide)
                              ? "none"
                              : "grayscale(50%) brightness(50%)",
                          }}
                        />
                        {getUnlocked(slide) ? (
                          <img
                            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quest/icon/PlayVideo.png"
                            alt="play"
                            className="play-icon"
                          />
                        ) : (
                          <>
                            <div className="overlay-locked" />
                            <img
                              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quest/icon/LockVideo.png"
                              alt="lock"
                              className="play-icon"
                            />
                          </>
                        )}
                      </>
                    )}
                  </div>
                );

                return (
                  <div
                    key={slide?.id}
                    className="carousel-item-slide-new text-center"
                  >
                    <div className="card-body">
                      {getUnlocked(slide) ? (
                        <div
                          onClick={() => {
                            navigate(
                              `/student/admin/episodes/detail/${slide.questID}/${slide.id}`,
                            );
                            window.location.reload();
                          }}
                        >
                          {content}
                          <p className="EpisodeTitle mb-0">
                            {slide.loading ? (
                              <Skeleton width={80} />
                            ) : (
                              slide.title
                            )}
                          </p>
                        </div>
                      ) : (
                        <>
                          {content}
                          <p className="EpisodeTitle mb-0">
                            {slide.loading ? (
                              <Skeleton width={80} />
                            ) : (
                              slide.title
                            )}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        onClick={goToPrev}
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        onClick={goToNext}
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default EpisodeCarousel;
